
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-test-gemini-api-key-fast",
      function () {
        return require("private-next-pages/how-to-test-gemini-api-key-fast.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-test-gemini-api-key-fast"])
      });
    }
  